import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {isAbsoluteUrl} from '@ui/utils/urls/is-absolute-url';

export function getMediaUrl(url?: string | null): string | undefined {
  if (!url) {
    return undefined;
  }

  if (isAbsoluteUrl(url)) {
    return url;
  }

  const baseUrl = getBootstrapData().settings.base_url;

  return `${baseUrl.replace(/\/$/, '')}/${url.replace(/^\/+/, '')}`;
}
